module.exports = __webpack_public_path__ + "static/img/select-img2.0637bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img2.png
// module id = WPRs
// module chunks = 1